import { lazy, Suspense } from 'react';

const newGameComponents = {
    escapeStalingradZ: lazy(() => import('../escapeStalingradZ/escapeStalingradZ_new.js')),
    hoplomachusV: lazy(() => import('../hoplomachusV/hoplomachusV_setup.js')),
    isofarianGuard: lazy(() => import('../isofarianGuard/isofarianGuard_setup.js')),
    lludwiksLabyrinth: lazy(() => import('../lludwiksLabyrinth/lludwiksLabyrinth_setup.js')),
    mhw: lazy(() => import('../monsterhunter/monsterhunter_new.js')),
    novaAetasRenaissance: lazy(() => import('../novaAetasRenaissance/novaAetasRenaissance_setup.js')),
    oathsworn: lazy(() => import('../oathsworn/oathsworn_new.js')),
    phantomEpoch: lazy(() => import('../phantomEpoch/phantomEpoch_new.js')),
    primalAwakening: lazy(() => import('../primalAwakening/primalAwakening_new.js')),
    stonesaga: lazy(() => import('../stonesaga/stonesaga_new.js')),
    soulRaiders: lazy(() => import('../soulRaiders/soulRaiders_new.js'))
};

const ongoingGameComponents = {
    escapeStalingradZ: lazy(() => import('../escapeStalingradZ/escapeStalingradZ_campaign.js')),
    hoplomachusV: lazy(() => import('../hoplomachusV/hoplomachusV_game.js')),
    isofarianGuard: lazy(() => import('../isofarianGuard/isofarianGuard_game.js')),
    lludwiksLabyrinth: lazy(() => import('../lludwiksLabyrinth/lludwiksLabyrinth_campaign.js')),
    mhw: lazy(() => import('../monsterhunter/monsterhunter.js')),
    novaAetasRenaissance: lazy(() => import('../novaAetasRenaissance/NovaAetasRenaissance_game.js')),
    oathsworn: lazy(() => import('../oathsworn/oathsworn_campaign.js')),
    phantomEpoch: lazy(() => import('../phantomEpoch/phantomEpoch_campaign.js')),
    primalAwakening: lazy(() => import('../primalAwakening/primalAwakening_game.js')),
    stonesaga: lazy(() => import('../stonesaga/stonesaga_campaign.js')),
    soulRaiders: lazy(() => import('../soulRaiders/soulRaiders_campaign.js'))
};

export function getNewGameComponent(gameId) {
  return newGameComponents[gameId] || null; // Handle non-existent gameIds
}

export function getOngoingGameComponent(gameId) {
  return ongoingGameComponents[gameId] || null; // Handle non-existent gameIds
}

